import { FC } from 'react'

import { ResourceHeader } from '@factorialco/factorial-one-react/dist/experimental'
import { TrainingRequestDetailFragment } from 'generated/resources/graphql'

import { getStatusLabel, getStatusVariant } from 'modules/trainings/lib/utils'

type Props = {
  myTrainingRequest: TrainingRequestDetailFragment
}

const RequestHeader: FC<Props> = ({ myTrainingRequest }) => {
  return (
    <ResourceHeader
      status={{
        label: '',
        text: getStatusLabel(myTrainingRequest.status),
        variant: getStatusVariant(myTrainingRequest.status),
      }}
      title={myTrainingRequest.trainingName ?? ''}
    />
  )
}

export default RequestHeader
